/**
 * CustomsChecklist — Step 17 rich detail.
 *
 * Required-document checklist with broker contact card. Each doc is a
 * row that toggles between "missing" and "uploaded" — uploaded shows
 * the filename so it feels real.
 */
import React from 'react';
import { Stamp, Mail, AlertTriangle, CheckCircle2, FileUp } from 'lucide-react';

const REQUIRED_DOCS = [
  { key: 'airWaybill',        label: 'Air waybill / bill of lading' },
  { key: 'certOfOrigin',      label: 'Certificate of origin' },
  { key: 'packingList',       label: 'Packing list' },
  { key: 'commercialInvoice', label: 'Commercial invoice' },
  { key: 'releaseOrder',      label: 'Customs release order' },
];

const CustomsChecklist = ({ order }) => {
  const customs = order.customs || {};
  const docs = customs.docs || {};

  return (
    <div className="manifest-rich-panel manifest-customs">
      <div className="manifest-rich-panel-head">
        <div className="manifest-rich-panel-title">
          <Stamp size={16} /> Customs clearance
        </div>
      </div>

      <div className="manifest-customs-broker">
        <div className="manifest-customs-broker-label">Broker</div>
        <div className="manifest-customs-broker-name">
          {customs.brokerName || '— assign a broker —'}
        </div>
        {customs.brokerContact && (
          <a href={`mailto:${customs.brokerContact}`} className="manifest-customs-broker-contact">
            <Mail size={11} /> {customs.brokerContact}
          </a>
        )}
      </div>

      <ul className="manifest-doc-list">
        {REQUIRED_DOCS.map((d) => {
          const doc = docs[d.key];
          const uploaded = !!doc?.uploaded;
          return (
            <li key={d.key} className={`manifest-doc-row state-${uploaded ? 'signed' : 'pending'}`}>
              <div className="manifest-doc-icon">
                {uploaded ? <CheckCircle2 size={18} /> : <AlertTriangle size={18} />}
              </div>
              <div className="manifest-doc-main">
                <div className="manifest-doc-label">{d.label}</div>
                {uploaded ? (
                  <div className="manifest-doc-filename">{doc.name}</div>
                ) : (
                  <div className="manifest-doc-why">Required for CBSA release</div>
                )}
              </div>
              <button className="manifest-btn-ghost-sm">
                {uploaded ? 'Replace' : <><FileUp size={11} /> Upload</>}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CustomsChecklist;
